import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class OpenApiService {
  constructor(protected http: HttpClient) {}

  public get<T>(route: string): Observable<T> {
    return this.http.get<T>(this.composeRoute(route, environment.openApiUrl));
  }

  public customPatchData<T>(route: string, body: unknown): Observable<T> {
    return this.http.patch<T>(this.composeRoute(route, environment.openApiUrl), body);
  }

  public post<T>(route: string, body?: unknown): Observable<T> {
    return this.http.post<T>(this.composeRoute(route, environment.openApiUrl), body, this.generateHeaders());
  }

  public update<T>(route: string, body: unknown): Observable<T> {
    return this.http.put<T>(this.composeRoute(route, environment.openApiUrl), body, this.generateHeaders());
  }

  public delete<T>(route: string, body: unknown = {}): Observable<T> {
    return this.http.delete<T>(this.composeRoute(route, environment.openApiUrl), body);
  }

  public upload<T>(route: string, file: File): Observable<T> {
    const formData = new FormData();
    formData.append('file', file);
    return this.http.post<T>(this.composeRoute(route, environment.openApiUrl), formData);
  }

  private composeRoute(route: string, environmentUrl: string) {
    return `${environmentUrl}/${route}`;
  }

  private generateHeaders() {
    return {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
    };
  }
}
